export default __webpack_public_path__ + "static/media/case3-logo.d3debe8d.webp";